<template>
    <div class="daterange-picker">

        <datepicker name="from" ref="fromDate"
                :placeholder="fromPlaceholder"
                :language="language"
                :monday-first="true"
                :format="dateFormat"
                :disabled="fromDisabled"
                v-model="value.from"

                :disabled-picker="fromDisabledPicker"

                :calendar-button="true"
                clear-button-icon="glyphicon glyphicon-remove"
                calendar-button-icon="glyphicon glyphicon-time"

                @input="fromChange"
        ></datepicker>

        <datepicker name="to" ref="toDate"
                :placeholder="toPlaceholder"
                :language="language"
                :monday-first="true"
                :format="dateFormat"
                :disabled="toDisabled"
                v-model="value.to"

                :calendar-button="true"
                clear-button-icon="glyphicon glyphicon-remove"
                calendar-button-icon="glyphicon glyphicon-time"

                @input="toChange"
                @cleared="cleared"
        ></datepicker>

        <div class="clearfix"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Datepicker from 'vuejs-datepicker';
    import lang from '../services/lang';
    export default {
        components: {
            Datepicker
        },
        props: {
            "dateFormat": {
                default: 'dd.MM.yyyy',
            },
            "language": {
                default: lang.current()
            },
            "dateStart": {},
            "value": {
                default: {
                    from: null,
                    to: null,
                }
            },
            "fromDisabled": {
                type: Object,
                default() {
                    return {
                        from: null,
                        to: null,
                    };
                },
            },
            "toDisabled": {
                type: Object,
                default() {
                    return {
                        from: null,
                        to: null,
                    };
                },
            },
            "fromHightlighted": {
                type: Object,
                default() {
                    return {
                        dates: []
                    }
                }
            },
            "toHightlighted": {
                type: Object,
                default() {
                    return {
                        dates: []
                    }
                }
            },
            "fromDisabledPicker": { default: false},
            "toDisabledPicker": { default: false},
        },
        data() {
            return {
                "fromPlaceholder":this.$translate.text('From'),
                "toPlaceholder": this.$translate.text('To'),
            };
        },
        mounted() {

        },
        methods: {
            type: function() {
//                console.log(this.$event)
            },
            fromChange: function(value) {
                this.datepickerChange(this.$refs.fromDate.name, value);
            },
            toChange: function(value) {
                this.datepickerChange(this.$refs.toDate.name, value);
            },
            datepickerChange: function(name, value)
            {
                switch (name)
                {
                    case this.$refs.fromDate.name:

                        if (this.$refs.fromDate.selectedDate)
                        {
                            if (this.$refs.toDate.selectedDate && this.$refs.fromDate.selectedDate.getTime() > this.$refs.toDate.selectedDate.getTime())
                            {
                                let tmp = this.$refs.toDate.selectedDate;

                                this.$refs.toDate.selectedDate = this.$refs.fromDate.selectedDate;
                                this.$refs.fromDate.selectedDate = tmp;
                            }
                        }

                        break;
                    case this.$refs.toDate.name:

                        if (this.$refs.toDate.selectedDate)
                        {
                            if (this.$refs.fromDate.selectedDate && this.$refs.toDate.selectedDate.getTime() < this.$refs.fromDate.selectedDate.getTime())
                            {
                                let tmp = this.$refs.fromDate.selectedDate;

                                this.$refs.fromDate.selectedDate =  this.$refs.toDate.selectedDate
                                this.$refs.toDate.selectedDate = tmp;
                            }
                        }

                        break;
                }

                this.$emit('input', {
                    from: this.$refs.fromDate.selectedDate,
                    to: this.$refs.toDate.selectedDate
                })
            },
            clear: function() {
                this.$refs.fromDate.clearDate();
                this.$refs.toDate.clearDate();
            },
            cleared: function() {
            }
        }
    }
</script>

<style scope>
    .daterange-picker {
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        padding: 7px 5px 5px 5px;
        background: #fff;
        color: #333;
        max-width:310px;
        font-size:14px;
    }

    .vdp-datepicker input {
        border:none;
        text-align:center;
        margin-left:2px;
        width:100px;
    }



    .vdp-datepicker {
        max-width:180px;
        margin-left: 5px;
        margin-right: 5px;
        float:left;
    }

    .vdp-datepicker .cell.day.today {
        border-color:yellow;
    }
</style>


// WEBPACK FOOTER //
// DateRangePicker.vue?0175d86f